import styled from 'styled-components';
var ModalOverlay = styled.div.withConfig({
  displayName: "Modalstyles__ModalOverlay",
  componentId: "pantheon__kl1i01-0"
})(["position:fixed;top:0;left:0;z-index:2001;width:100%;height:100%;background-color:#000;opacity:0.5;*{transition:height 5s ease;}"]);
var ModalWrapper = styled.div.withConfig({
  displayName: "Modalstyles__ModalWrapper",
  componentId: "pantheon__kl1i01-1"
})(["position:fixed;top:0;left:0;z-index:2050;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0;transform:translateY(50%);animation:slideInSmooth 0.5s forwards;@keyframes slideInSmooth{from{transform:translateY(2%);opacity:0;}to{transform:translateY(0);opacity:1;}}"]);
var ModalContainer = styled.div.withConfig({
  displayName: "Modalstyles__ModalContainer",
  componentId: "pantheon__kl1i01-2"
})(["z-index:100;background:white;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);border-radius:3px;max-width:500px;"]);
var ModalHeader = styled.div.withConfig({
  displayName: "Modalstyles__ModalHeader",
  componentId: "pantheon__kl1i01-3"
})(["right:1.3rem;top:0.625rem;position:absolute;"]);
var ModalCloseButton = styled.button.withConfig({
  displayName: "Modalstyles__ModalCloseButton",
  componentId: "pantheon__kl1i01-4"
})(["background-color:transparent;border:none;cursor:pointer;"]);
export { ModalCloseButton, ModalContainer, ModalHeader, ModalOverlay, ModalWrapper };